import { InitialsPipe } from './initials.pipe';
import { NgModule } from '@angular/core';
import { DatePipe } from './date.pipe';
import { OrderByPipe, SortByPipe } from './sort-by.pipe';
import { SafeHtmlPipePipe } from './safe-html-pipe.pipe';
import { TurfDatePipe } from './turf-date/turf-date.pipe';
import { CurrencyFormatterPipe } from './currency-formatter.pipe';
import { DateCountdownPipe } from './date-countdown/date-countdown.pipe';
@NgModule({
  declarations: [InitialsPipe, DatePipe, SortByPipe, SafeHtmlPipePipe, TurfDatePipe, CurrencyFormatterPipe, OrderByPipe, DateCountdownPipe],
  exports: [InitialsPipe, SortByPipe,SafeHtmlPipePipe, TurfDatePipe, CurrencyFormatterPipe, OrderByPipe, DateCountdownPipe],
})
export class PipesModule { }
